import React, { useEffect, useState } from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/LatestNews/Banner'
import BlogList from '../Component/LatestNews/BlogList'
import CVReviewSection from '../Component/HomePage/CVReviewSection'
import Footer from '../Component/NavBarFooter/Footer'
import { useAuth } from '../Context/ContextProvider'

function LatestNews() {
  const [newsList, setNewsList] = useState([])

  const { getAllNews } = useAuth()
  useEffect(() => {
    const newsFetech = async () => {
      try {
        let result = await getAllNews()
        if (result.success) {
          setNewsList(result.data?.newsList)
        }
      }
      catch {

      }
    }
    newsFetech()
  }, [])
  return (
    <div>
      <NavBar />
      <Banner />
      <BlogList newsList={newsList} />
      <CVReviewSection />
      <Footer />

    </div>
  )
}

export default LatestNews